export default __webpack_public_path__ + "static/media/questlogo.9c9a19e9.png";